import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgCheckMark = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.068 56.605" {...props}><Defs></Defs><G filter="url(#a)"><Path fill="none" stroke="currentColor" strokeMiterlimit={10} strokeWidth={10} d="m60.534 7.535-34 34-17-17" data-name="check" /></G></Svg>;
const Memo = memo(SvgCheckMark);
export default Memo;